(function ($, Cobalt, undefined) {
    var dayAbbrs = [
        "SundayAbbr",
        "MondayAbbr",
        "TuesdayAbbr",
        "WednesdayAbbr",
        "ThursdayAbbr",
        "FridayAbbr",
        "SaturdayAbbr"
    ];

    var getDayAbbr = function (index) {
        var abbr = dayAbbrs[index];
        if (abbr == null) {
            return;
        }
        var L = Cobalt.Localization.Main;
        if (L && L.Global && L.Global.Dates && L.Global.Dates[abbr]) {
            return L.Global.Dates[abbr]();
        }

        return abbr.substring(0, 3);
    };

    var monthAbbrs = [
        "JanuaryAbbr",
        "FebruaryAbbr",
        "MarchAbbr",
        "AprilAbbr",
        "MayAbbr",
        "JuneAbbr",
        "JulyAbbr",
        "AugustAbbr",
        "SeptemberAbbr",
        "OctoberAbbr",
        "NovemberAbbr",
        "DecemberAbbr"
    ];

    var monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];

    var getMonthAbbr = function (index) {
        var abbr = monthAbbrs[index];
        var L = Cobalt.Localization.Main;
        if (L && L.Global && L.Global.Dates && L.Global.Dates[abbr]) {
            return L.Global.Dates[abbr]();
        }

        return abbr.substring(0, 3);
    };

    var getMonthName = function (index) {
        var name = monthNames[index];
        var L = Cobalt.Localization.Main;
        if (L && L.Global && L.Global.Dates && L.Global.Dates[name]) {
            return L.Global.Dates[name]();
        }

        return name;
    };

    var getDateFormatRanges = function () {
        // 59 mins, 23 hours, 6 days
        var defaultRanges = [59, 1380, 8640];

        if (typeof NiceDatesSettings != 'undefined')
            return NiceDatesSettings;
        else
            return defaultRanges;
    };

    var translate = function (key, defaultValue) {
        var L = Cobalt.Localization.Main;
        if (L && L.Global && L.Global.Dates && L.Global.Dates[key]) {
            return function () {
                return L.Global.Dates[key].apply(null, arguments);
            };
        }

        if (defaultValue.indexOf("{0") != -1) {
            return function () {
                return defaultValue.format.apply(defaultValue, arguments)
            };
        } else {
            return function () {
                return defaultValue;
            }
        }
    }

    var zeroPadLeft = function (data, amount) {
        data = data.toString();
        while (data.length < amount) {
            data = "0" + data;
        }
        return data;
    }

    Cobalt.NiceDates = {
        priority: 0,
        isRunningNiceDates: false,
        isRunningNicePreciceDates: false,
        initialize: function () {
            var DateFormatRanges = getDateFormatRanges();
            Cobalt.NiceDates.runNiceDates($(document), DateFormatRanges);
            Cobalt.NiceDates.runNicePreciseDates($(document), DateFormatRanges);
            Cobalt.runOnHtmlInsert(Cobalt.NiceDates.runNiceDates);
            Cobalt.runOnHtmlInsert(Cobalt.NiceDates.runNicePreciseDates);
        },
        initializeNiceDates: function (dateFormatRanges) {
            Cobalt.NiceDates.runNiceDates($(document), dateFormatRanges);
            setTimeout(Cobalt.NiceDates.initializeNiceDates, 60000);
        },
        initializeNicePreciseDates: function (dateFormatRanges) {
            Cobalt.NiceDates.runNicePreciseDates($(document), dateFormatRanges);
            setTimeout(Cobalt.NiceDates.initializeNicePreciseDates, 1000);
        },
        runNiceDates: function ($parent, dateFormatRanges) {
            if (!$parent) {
                $parent = $(document);
            }
            if (!dateFormatRanges) {
                dateFormatRanges = getDateFormatRanges();
            }
            var foundDates = $parent.find(".standard-datetime, .standard-date, .localized-date-string");
            if (foundDates.length > 0 && Cobalt.NiceDates.isRunningNiceDates == false) {
                Cobalt.NiceDates.isRunningNiceDates = true;
                Cobalt.NiceDates.initializeNiceDates(dateFormatRanges);
            }

            foundDates.each(function () {
                Cobalt.NiceDates.preFormatTitleAttribute($(this));
                Cobalt.NiceDates.formatNiceDate($(this), dateFormatRanges);
            });
        },
        preFormatTitleAttribute: function (element) {
            if (element.is("[title]") && element.attr("time-processed") == null) {
                var datePrefix = element.attr("data-date-prefix");
                var localDate = new Date(element.attr("title"));
                var localDateString = localDate.toLocaleDateString();
                var localHour = localDate.getHours();
                var localMinutes = localDate.getMinutes();
                if (localMinutes < 10) {
                    localMinutes = "0" + localMinutes.toString();
                }
                var amPm = "";

                if (localHour < 12) {
                    amPm = "AM";
                }
                else {
                    amPm = "PM";
                }

                if (localHour == 0) {
                    localHour = 12;
                }

                if (localHour > 12) {
                    localHour = localHour - 12;
                }

                var formattedString = (datePrefix || "") + localDateString + " " + localHour + ":" + localMinutes + " " + amPm;
                element.attr("title", formattedString);
                element.attr("time-processed", "true");
            }
        },
        runNicePreciseDates: function ($parent, dateFormatRanges) {
            if (!$parent) {
                $parent = $(document);
            }
            if (!dateFormatRanges) {
                dateFormatRanges = getDateFormatRanges();
            }
            var foundDates = $parent.find(".standard-datetime-precise");
            if (foundDates.length > 0 && Cobalt.NiceDates.isRunningNicePreciceDates == false) {
                Cobalt.NiceDates.isRunningNicePreciceDates = true;
                Cobalt.NiceDates.initializeNicePreciseDates(dateFormatRanges);
            }

            foundDates.each(function () {
                Cobalt.NiceDates.formatNiceDate($(this), dateFormatRanges);
            });
        },
        formatNiceDate: function (element, dateFormatRanges) {
            var now = Cobalt.newDate();
            var epoch = element.attr("data-epoch");
            if (epoch) {
                var epochNumber = parseInt(epoch);
                var date = new Date(parseInt(epoch) * 1000);
                var deltaMinutes = ((now - date) / 1000) / 60;
                if (deltaMinutes < 0) {
                    deltaMinutes = Math.ceil(deltaMinutes);
                } else {
                    deltaMinutes = Math.floor(deltaMinutes);
                }
                var ago;
                if (deltaMinutes < 0) {
                    ago = translate("FutureFormat", "{0} from now");
                    deltaMinutes *= -1;
                } else {
                    ago = translate("PastFormat", "{0} ago");
                    element.closest(".j-nicedate").find(".j-nicedate-future").hide().end().find(".j-nicedate-past").show();
                }

                var precise = element.hasClass("standard-datetime-precise");

                if (precise && deltaMinutes >= 1) {
                    element.removeClass("standard-datetime-precise").addClass("standard-datetime");
                    precise = false;
                }

                if (element.hasClass("localized-date-string")) {
                    var text = translate("StandardLocalizedDateString", "{0}, {1} {2} {3}:{4}:{5}");
                    element.text(text(getMonthAbbr(date.getMonth()), date.getDate(), date.getFullYear(), zeroPadLeft(date.getHours(), 2), zeroPadLeft(date.getMinutes(), 2), zeroPadLeft(date.getSeconds(), 2)));
                }
                else if (deltaMinutes < 1) { // Seconds
                    if (precise) {
                        var text = translate("Seconds", "{0} sec");
                        element.text(ago(text(Math.floor((now - date) / 1000))));
                    } else {
                        var text = translate("LessThanOneMinute", "\u003c1 min");
                        element.text(ago(text()));
                    }
                } else if (deltaMinutes == 1) { // Exactly 1 Minute
                    var text = translate("OneMinute", "1 min");
                    element.text(ago(text()));
                } else if (deltaMinutes < dateFormatRanges[0]) { // Minutes
                    var text = translate("Minutes", "{0} mins");
                    element.text(ago(text(deltaMinutes)));
                } else if (deltaMinutes < dateFormatRanges[1]) { // Hours
                    var text = translate("Hours", "{0} hours");
                    element.text(ago(text(Math.round(deltaMinutes / 60))));
                } else if (deltaMinutes < dateFormatRanges[2]) { // Days
                    var text = translate("Days", "{0} days");
                    element.text(ago(text(Math.round(deltaMinutes / 1440))));
                } else { // Non-Relative Time
                    if (element.hasClass("standard-date")) {

                        var text = translate("StandardDateFormat", "{0} {1} {2}");

                        element.text(text(date.getDate(), getMonthAbbr(date.getMonth()), date.getFullYear()));
                    } else {
                        var text = translate("StandardDateTimeFormat", "{2}, {3} {1} {0} {4}:{5}:{6}");
                        element.text(text(date.getDate(), getDayAbbr(date.getDay()), zeroPadLeft(date.getHours(), 2), zeroPadLeft(date.getMinutes(), 2), getMonthAbbr(date.getMonth()), zeroPadLeft(date.getSeconds(), 2), date.getFullYear()));
                    }
                }
            }
        },
        formatMobileDates: function() {
            
        }
    };

})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.NiceDates.js